<template>
  <!-- 查询管理员账号 author: zhangxiaofeng -->
  <page-board page-title="查询管理员账号">
    <div class="find-admin--main">
      <form action="javascript: void(0);" @submit="startQuery">
        <p class="f-cb">
          <label>查询方式</label>
          <select name="searchType" v-model="lockType" @change="changeLockType"
                  :class="[errorType === 1 ? 'error' : '']"  @input="errorType = 0">
            <option v-for="(item, idx) in lockTypeList" :key="idx" :value="item.value">
              {{item.name}}
            </option>
          </select>
          <i v-if="detectedLock" class="r2-icon-nav_check"></i>
        </p>
        <!-- 给出错误提示 -->
        <p class="error f-cb">
          <label></label>
          <span v-if="errorType === 1">{{errorTips[errorType]}}</span>
        </p>

        <p class="f-cb" v-if="lockType === 'manual'">
          <label>
            <i>*</i>
            加密锁号
          </label>
          <input type="text" :class="[errorType === 2 ? 'error' : '']"  @input="errorType = 0" v-model.trim="lockNumber">
        </p>
        <!-- 给出错误提示 -->
        <p class="error f-cb">
          <label></label>
          <span v-if="errorType === 2">{{errorTips[errorType]}}</span>
        </p>

        <p class="f-cb">
          <label>
            <i>*</i>
            验证码
          </label>
          <input type="text" :class="['w-220', errorType === 3 || errorType === 210001 ? 'error' : '']"
                 v-model.trim="verificationCode" @input="errorType = 0">
          <span  class="verification-code">
            <img :src="verificationCodeSrc + lockType + '&timer=' + verificationCodeTimer"
                 :key="verificationCodeTimer"
                 @click="refreshVerification()"/>
          </span>
        </p>
        <!-- 给出错误提示 -->
        <p class="error f-cb">
          <label></label>
          <span v-if="errorType > 2">{{errorTips[errorType]}}</span>
        </p>

        <!-- 查询到管理员账号时 -->
        <p class="result f-cb" v-if="adminName">
          <label></label>
          <span>管理员账号：{{adminName}}</span>
        </p>

        <p class="f-cb">
          <label></label>
          <button v-if="!adminName" type="submit" :class="[canSubmit ? 'blue' : 'gray']">查询管理员账号</button>
          <button v-if="adminName" type="button" class="blue" @click="toLogin">前往登陆</button>
          <router-link class="button" to="/index">取消</router-link>
        </p>
      </form>
    </div>
  </page-board>
</template>
<style lang="less" type="text/less" scoped>
  .find-admin--main{
    width: 568px;
    margin:  0 auto;
    height: auto;
    position: relative;
    min-height:200px;
    background: rgb(255,255,255);
    box-shadow:0px 1px 4px 0px rgba(33,37,48,0.1);
    border-radius:2px;
    box-sizing: border-box;
    padding: 35px 80px 40px 80px;
    margin-top: 24px;
    form{
      p{
        width: 100%;
        position: relative;
        height: 32px;
        line-height: 32px;
        margin-bottom: 24px;
        position: relative;
        .verification-code{
          width: 84px;
          height: 38px;
          text-align: center;
          /*line-height: 38px;*/
          position: relative;
          border: 1px solid black;
          box-sizing: border-box;
          margin-top: -4px;
          img{
            width: 100%;
          }
        }
        &>*{
          float: left;
          display: inline-block;
        }
        .r2-icon-nav_check{
          position: absolute;
          color: #00C461;
          font-size: 24px;
          right: -32px;
        }
        label{
          width: 88px;
          height: 100%;
          position: relative;
          i{
            position: absolute;
            left: -16px;
            top: 2px;
            color: red;
          }
        }
        input, select{
          width: 320px;
          height: 32px;
          line-height: 32px;
          outline: none;
          border-radius:4px;
          border: 1px solid #DEDFE0;
          color: rgba(33, 37, 48, 0.8);
          &:hover, &:focus{
            border-color: #2079FA;
          }
          &.error{
            border-color: #E02020;
            color: rgba(33, 37, 48, 0.35);
          }
          box-sizing: border-box;
          padding: 0 8px 0 12px;
          &.w-220{
            width: 220px;
            margin-right: 16px;
          }
        }
        &.result{
          margin-bottom: 0;
          padding-bottom: 16px;
          padding-top: 16px;
          height: 24px;
          line-height: 24px;
          font-size: 16px;
          font-weight: 500;
          color: rgba(33,37,48,0.75);
        }
        &.error{
          height: 20px;
          line-height: 20px;
          margin-bottom: 4px;
          margin-top: -24px;
          font-size:12px;
          font-weight:400;
          color: #E02020;
        }
        &:last-child{
          margin-bottom: 0;
          margin-top: 20px;
        }
        button, a.button{
          cursor: pointer;
          border-radius:4px;
          padding: 5px 16px;
          font-size: 14px;
          font-weight:400;
          line-height: 22px;
          border:1px solid rgb(217,217,217);
          color: #212530;
          margin-right: 12px;
          background-color: #fff;
          &:last-child{
            margin-right: 0;
          }
          &.gray{
            background:rgba(33,37,48,0.35);
            color: #fff;
            border: none;
          }
          &.blue{
            background-color: #2079FA;
            color: #fff;
            border: none;
          }
        }
      }
    }
  }
</style>
<script>
import PageBoard from '_c/PageBoard.vue'
import {backendUrl} from '@/assets/js/config'
import { getCookie, setCookie } from '@/assets/utils/CommonUtil'
import LoginService from '@/assets/service/login'
export default {
  name: 'FindAdmin',
  data () {
    return {
      verificationCode: '', // 验证码
      verificationCodeSrc: backendUrl + '/common/captcha?type=',
      verificationCodeTimer: new Date().getTime(), // 二维码时间戳
      lockNumber: '', // 手动输入的锁号
      lockNumberAuto: '', // 自动检测到的锁号
      lockType: 'manual', // 获取加密锁的方式 默认手动获取
      lockTypeList: [
        {name: '手动输入加密锁查询管理员账号', value: 'manual'},
        {name: '通过本地加密锁查询管理员账号', value: 'auto'}
      ],
      adminName: '',
      errorType: 0,
      errorTips: { // 错误提醒
        1: '未搜索到加密锁，请手动获取',
        2: '请输入加密锁号',
        3: '请输入验证码',
        404: '未搜索到对应企业，请重新输入',
        500: '请求异常，请稍后再试',
        210001: '图形验证码输入错误，请重新输入'
      },
      detectedLock: false // 是否自动检测到加密锁
    }
  },
  computed: {
    // 是否能提交
    canSubmit () {
      let can = false
      if (this.verificationCode !== '' && (this.lockNumber !== '' || this.lockNumberAuto !== '')) {
        can = true
      }
      return can
    }
  },
  mounted () {
    this.sentLog(100101032, {type: 1})
  },
  methods: {
    // 2. 获取方式切换时
    changeLockType () {
      this.resetData()
      switch (this.lockType) {
        case 'auto': // 自动获取加密锁号
          this.sentLog(100101032, {type: 2})
          let adminKey = ''
          const noKey = () => {
            return adminKey === null || adminKey === undefined || adminKey.indexOf('"') === -1
          }
          try {
            adminKey = GSCEngine.GetDeviceList(1) // 尝试获取本地锁
            if (noKey()) {
              // console.log('-----------------')
              adminKey = GSCEngine.GetDeviceList(2) // 尝试获取网络锁
            }
            console.log('adminKey: ' + adminKey) // adminKey: "["ZZ320613534"]"
            if (noKey()) {
              this.showTips(1, true)
            } else {
              adminKey = JSON.parse(adminKey)
              if (adminKey.length > 0) {
                this.detectedLock = true // 自动检测到加密锁
                this.lockNumberAuto = adminKey[0]
              } else {
                this.showTips(1, true)
              }
            }
          } catch (e) {
            console.log(e)
            this.showTips(1, true)
          }
          break
        default:
          this.sentLog(100101032, {type: 1})
      }
    },
    // 3. 开始查询 管理员账号
    startQuery () {
      if (this.canSubmit) {
        let authHardwareId = this.lockNumber
        if (this.lockType === 'auto') {
          authHardwareId = this.lockNumberAuto
        }
        let uuid = getCookie('simpleCaptcha_' + this.lockType) // uuid 写在指定域下的 本地获取不到
        this.sentLog(100101033, {type: this.lockType === 'auto' ? 2 : 1})
        LoginService.getAdminAccount({
          authHardwareId,
          type: this.lockType,
          checkCode: this.verificationCode,
          timer: new Date().getTime(),
          uuid
        }).then((result) => {
          if (+result.code === 210001) {
            this.showTips(210001)
          } else {
            if (+result.code === 200 && result.data) {
              // 成功读取到加密锁号
              this.adminName = result.data
            } else {
              // 根据加密锁号 获取不到对应企业
              this.showTips(404)
            }
          }
        }).catch((e) => {
          console.log(e)
          this.showTips(500)
        })
      } else {
        if (this.lockType === 'auto') {
          if (!this.lockNumberAuto) {
            this.showTips(1)
          } else {
            this.showTips(3)
          }
        } else {
          if (!this.lockNumber) {
            this.showTips(2)
          } else {
            this.showTips(3)
          }
        }
      }
    },
    // 4. 重置 data
    resetData (type) {
      this.errorType = 0
      this.detectedLock = false
      this.verificationCode = ''
      if (!type) {
        this.canSubmit = false
        this.lockNumber = ''
        this.lockNumberAuto = ''
        this.adminName = ''
      }
    },
    // 5. 显示提示信息
    showTips (type) {
      this.errorType = type
      switch (type) {
        case 1: // 未搜索到加密锁，
          break
        case 2: // 请输入加密锁号
        case 3: // 未输入验证码
          break
        default:
          // 404 500 210001
          if (type === 210001) {
            this.verificationCode = ''
          }
          this.refreshVerification()
      }
    },
    // 6. 前往登陆
    toLogin () {
      if (this.adminName !== '') {
        setCookie('ADMIN_COUNT_HIT', this.adminName)
        this.$router.push({
          path: '/index'
        })
      }
    },
    // 刷新二维码
    refreshVerification () {
      this.verificationCodeTimer = new Date().getTime()
    }
  },
  components: {
    PageBoard
  }
}
</script>
